<!--
  作者：xiaoyu.li
  时间：2020年03月14日 21:38:48
-->
<template>
  <div class="activity_card">
    <div
      class="content-box flex-center"
      @click="
        link(
          `id=${el.activityId}&shareId=${el.shareId}&vcardUrl=${vcardUrl}`,
          el
        )
      "
    >
      <div class="tag">
				<img src="../assets/tag_leaf.svg" style="width: 62px; height: 28px"/>
			</div>
			<div class="tag">
				{{ el.activityType === 'OFFLINE' ? '同城活动' : '福利活动' }}
			</div>
      <van-image
        style="margin-right: 12px;"
        fit="cover"
        radius="5px"
        width="136"
        height="80"
        lazy-load
        :src="el.bannerUrl"
      />
      <div>
        <div class="title van-multi-ellipsis--l2">
          {{ el.activityName }}
        </div>
        <div class="subtitle">
          {{ el.startTime }} 至
          {{ el.dueTime }}
        </div>
      </div>
    </div>
    <div
      class="flex-center"
      style="margin-top: 8px; justify-content: space-between;"
    >
      <div
        class="flex-center"
        style="font-size: 13px; line-height: 22px; color: #969799;"
        @click="
          link(
            `id=${el.activityId}&shareId=${el.shareId}&vcardUrl=${vcardUrl}`,
            el
          )
        "
      >
        <image
          style="width: 16px;height: 16px; margin-right: 8px;"
          src="../static/list-1.svg"
        ></image>
        已有 {{ el.enter || 0 }} 人报名参加
      </div>
      <van-button
        plain
        type="primary"
        round
        :color="
          moment() > moment(el.dueTime)
            ? '#7D7E80'
            : el.enterFlag
            ? '#52C41A'
            : moment() < moment(el.startTime)
            ? '#7D7E80'
            : '#1F7DDE'
        "
        size="small"
        :disabled="
          moment() > moment(el.dueTime) ||
            el.enterFlag ||
            moment() < moment(el.startTime)
        "
        @click="
          link(
            `id=${el.activityId}&shareId=${el.shareId}&vcardUrl=${vcardUrl}`,
            el
          )
        "
      >
        立即报名
      </van-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
 import Vue from 'vue'
import env from '@/config/env'
export default {
  // 组件名称
  name: 'ActivityCard',
  // 组件参数 接收来自父组件的数据
  props: {
    shareId: {
      type: String,
      default: '',
    },
    envMp: {
      type: Boolean,
      default: false,
    },
    vcardUrl: {
      type: String,
      default: '',
    },
    pagesType:{
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: function() {
        return {
          activityId: '8a69c6d2705b93c201705b9bb8f00003',
          activityName: '3月家装节等你来参加',
          activityType: '',
          address: '暂只支持线上',
          needFee: 'Y',
          entryFee: 1,
          description: '单品享秒杀，套购折上折',
          startTime: '2020-01-01',
          endTime: '2019-03-01T17:00:00Z',
          enterLimitTime: '2019-04-01',
          serviceTel: '666666',
          activityStatus: 'END',
          bannerUrl:
            'https://img.esenyun.com/images/20200219/c156038efcbd4c6ab832abf4277f4ea0.jpg',
          createdBy: 'sns_wxcp_u_ve',
          createdTime: '2020-02-19T04:01:37Z',
          version: 0,
          activityUrl:
            'https://img.esenyun.com/images/20200219/c4ddf4aed60d48d7a386f6bb6aa2ba41.jpg',
          search: null,
          balance: 20000,
          visit: 0,
          star: 0,
          enter: 0,
          forward: 0,
          createdTimeFormat: '20天前',
          activityStatusName: '已结束',
          enterFlag: null,
          createdAvatar: null,
          uv: 0,
          lastModifiedBy: null,
          lastModifiedTime: null,
        }
      },
    },
  },
  computed: {
    el() {
      this.item.startTime = this.moment(this.item.startTime).format(
        'YYYY-MM-DD HH:mm'
      )
      this.item.endTime = this.moment(this.item.endTime).format(
        'YYYY-MM-DD HH:mm'
      )
      this.item.enterLimitTime = this.moment(this.item.enterLimitTime).format(
        'YYYY-MM-DD HH:mm'
      )
      this.item.dueTime = this.item.activityType === 'OFFLINE' ? this.item.endTime : this.item.enterLimitTime
     return this.item
    },
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {}
  },
  // 计算属性
  mounted() {},
  // 组件方法
  methods: {
   async link(path, item) {
      // console.log(path)
      if (this.envMp) {
        window.wx.miniProgram.navigateTo({
          url: `/pages/detail?id=${item.activityId}&shareId=${item.shareId}`,
        })
      } else {
        if(this.pagesType&&this.pagesType==='slot'){
          // console.log('this.pagesType',this.pagesType)
          let items=this.el
           let url= `id=${items.activityId}&shareId=${this.shareId}&vcardUrl=${this.vcardUrl}`
          // window.location.href=env.h5Url+url
           let redirectUri='activitydetail'
           Vue.ss.set('pageUrl',url)
          console.log('redirectUri',redirectUri)
          Vue.ss.set('redirectUri',redirectUri)
          console.log(url)
          console.log('pageUrl',Vue.ss.get('pageUrl'))
          if(this.$store.getters.isWeiXin){
            await this.$store.dispatch("wxLogin/wxLogin");
          }else{
              this.$Dialog.alert({
                message: '请在微信客户端打开链接',
              }).then(() => {
                // on close
              });
          }
        }else{
          let url=path
          // window.location.href=env.h5Url+url
           let redirectUri='activitydetail'
           Vue.ss.set('pageUrl',url)
          console.log('redirectUri',redirectUri)
          Vue.ss.set('redirectUri',redirectUri)
          console.log(url)
          console.log('pageUrl',Vue.ss.get('pageUrl'))
          if(this.$store.getters.isWeiXin){
            await this.$store.dispatch("wxLogin/wxLogin");
          }else{
              this.$Dialog.alert({
                message: '请在微信客户端打开链接',
              }).then(() => {
                // on close
              });
          }
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.activity_card {
  background: #fff;
  padding: 12px 16px;
  margin-bottom: 8px;
  /deep/.van-image__img {
    border-radius: 5px;
  }
  .content-box {
		position: relative;
		.tag {
			font-size: 12px;
			font-weight: 300;
			line-height: 28px;
			text-align: center;
			color: white;
			position: absolute;
			width: 62px;
			height: 28px;
			right: 0px;
		}
  }
  .title {
    width: 195px;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    color: #000;
  }
  .subtitle {
    font-size: 10px;
    line-height: 20px;
    color: #4a4a4a;
    margin-top: 10px;
  }
}
</style>
